import React, { ReactNode } from "react";
import "../pageTemplate.css";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  CssBaseline,
  styled,
  Paper,
  Button,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { logout } from "../../utils/apiHelper";
import PurchaseOrderVerification from "./components.tsx/purchaseOrder";

// Styled components for custom styling
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#000000",
  color: "#ffffff",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  zIndex: theme.zIndex.drawer + 1,
}));

interface PageTemplateProps {
  children?: ReactNode;
}

const SecurityDashboard: React.FC<PageTemplateProps> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <CssBaseline />

      {/* Top AppBar */}
      <StyledAppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
            NuLook ERP - Security Portal
          </Typography>
          <Button
            color="inherit"
            startIcon={<LogoutIcon />}
            onClick={() => logout()}
          >
            Logout
          </Button>
        </Toolbar>
      </StyledAppBar>

      {/* Main content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          mt: 8, // Adjusted for AppBar height
        }}
      >
        <Paper
          elevation={0}
          sx={{ bgcolor: "background.paper", minHeight: "80vh" }}
        >
          {/* Render the purchase order verification component directly */}
          <PurchaseOrderVerification />
          
          {/* Or render children if provided */}
          {children}
        </Paper>
      </Box>
    </Box>
  );
};

export default SecurityDashboard;
